import React from 'react';
import { Box } from '@mui/material';

export const Logo = () => {
  return (
    <Box
      component="svg"
      sx={{ fill: 'currentColor', height: '2rem', display: 'inline-block' }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-210 145 120 100"
      aria-hidden="true"
    >
      <path d="M -150.368 175.29 C -151.551 175.041 -122.409 147.935 -96.673 150.65 C -96.673 150.65 -123.896 181.964 -126.143 212.367 C -126.584 214.743 -137.425 184.042 -107.411 156.669 C -107.253 157.699 -120.812 158.687 -150.368 176.474 C -150.373 176.481 -167.729 169.1 -199.565 158.111 C -197.239 157.723 -156.306 200.055 -178.339 236.994 C -178.102 235.952 -177.361 224.048 -182.104 207.769 C -186.589 192.375 -192.729 172.257 -208.558 153.197 C -208.346 152.936 -187.181 145.283 -150.368 175.29 Z" />
      <path d="M -173.168 173.567 C -173.168 173.567 -158.052 190.07 -159.366 216.848 C -159.366 216.848 -149.508 209.376 -142.935 209.376 C -142.935 209.376 -139.978 190.692 -134.72 181.974 C -134.72 181.974 -140.634 186.956 -146.879 207.818 C -146.879 207.818 -153.123 209.687 -154.437 210.621 C -154.437 210.621 -157.722 184.776 -173.168 173.567 Z" />
    </Box>
  );
};
